export const PickerTypes = {
  MEDIA_BRIDGE: 'MEDIA_BRIDGE',
  HUBSPOT_VIDEO: 'HUBSPOT_VIDEO',
  DIGITAL_ASSET: 'DIGITAL_ASSET'
};
export const REQUEST_STATUS_TYPES = {
  UNINITIALIZED: 'UNINITIALIZED',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  NOT_FOUND: 'NOT_FOUND'
};
export const IFRAME_ID = 'mb_iframe';
export const MB_POST_MESSAGE_TYPE = 'mb-iframe';
export const PANEL_WIDTH = 600;
export const HUBSPOT_VIDEO_PROVIDER_IDS = {
  qa: 1204600,
  prod: 228194
};
export const HUBSPOT_VIDEO_2_PROVIDER_IDS = {
  qa: 1363048,
  prod: 316910
};
export const VIDMILE_DEMO_APP_IDS = {
  qa: 1203953,
  prod: 225894
};
export const noop = () => {};